import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Slide - Pure component for individual slider slide
 * Follows React Rules: Pure, idempotent, immutable props
 * 
 * @param {Object} slide - Slide data object
 * @param {string} slide.title - Main title
 * @param {string} slide.subtitle - Subtitle text
 * @param {string} slide.price - Price text
 * @param {string} slide.link - Link URL
 * @param {string} slide.linkText - Link text
 * @param {string} slide.animationStyle - Animation style class
 * @param {string} slide.bgClass - Background class
 */
const Slide = ({ slide }) => {
  const {
    title,
    subtitle,
    price,
    link = '/store/shop',
    linkText = 'Shopping Now',
    animationStyle = 'animation-style-01',
    bgClass = 'bg-1'
  } = slide;

  return (
    <div className={`single-slide align-center-left ${animationStyle} ${bgClass}`}>
      <div className="slider-progress"></div>
      <div className="slider-content">
        {subtitle && <h5 dangerouslySetInnerHTML={{ __html: subtitle }} />}
        {title && <h2>{title}</h2>}
        {price && <h3 dangerouslySetInnerHTML={{ __html: price }} />}
        <div className="default-btn slide-btn">
          <Link className="links" to={link}>
            {linkText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Slide;

